import React, { useState } from "react";
import { useResendActivation } from "./api";
import { useNavigate, useLocation } from "react-router-dom"; // Add useLocation
import { toast } from "react-toastify";
import warningIcon from "../../assets/warning_icon.svg";

export default function NotActivated() {
  const location = useLocation(); // Get location to access state
  const navigate = useNavigate();

  // Get email from location state, default to empty string if not available
  const [email, setEmail] = useState(location.state?.email || "");
  const [resendSuccess, setResendSuccess] = useState(false);

  const resendActivationMutation = useResendActivation();

  const handleResend = () => {
    if (!navigator.onLine) {
      toast.error("No internet connection. Please check your network.");
      return;
    }
    if (email) {
      resendActivationMutation.mutate(email, {
        onSuccess: (data) => {
          setResendSuccess(true);
          toast.success(
            data.message || "A new activation link has been sent to your email"
          );
        },
        onError: (err: any) => {
          // console.error("Failed to resend activation link:", err);
          toast.error(
            err.response?.data?.message || "Failed to send activation link"
          );
        },
      });
    } else {
      toast.error("Please enter your email address");
    }
  };

  return (
    <div className='flex items-center justify-center bg-gray-50 px-4 h-[calc(100vh-6rem)]'>
      <div className='w-full max-w-md bg-white rounded-xl shadow-lg p-8 text-center'>
        <div>
          <img
            src={warningIcon}
            alt='Warning Icon'
            className='h-20 w-20 mx-auto mb-4'
          />
          <h1 className='mt-6 text-lg font-semibold'>Account Not Activated</h1>

          {!resendSuccess ? (
            <>
              <p className='text-sm text-gray-500 mt-2'>
                Your account is not activated, and the activation link has
                expired.
              </p>

              <div className='mt-4'>
                <button
                  onClick={handleResend}
                  disabled={resendActivationMutation.isPending || !email}
                  className='mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 mr-2 disabled:bg-gray-300'
                >
                  {resendActivationMutation.isPending
                    ? "Sending..."
                    : "Resend Activation Link"}
                </button>
                <button
                  onClick={() => navigate("/log-in")}
                  className='mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'
                >
                  Back to Login
                </button>
              </div>
            </>
          ) : (
            <>
              <p className='text-sm text-gray-500 mt-2'>
                A new activation link has been sent to your email. Please check
                your inbox.
              </p>
              <button
                onClick={() => navigate("/log-in")}
                className='mt-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600'
              >
                Back to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
